<script>
import { cloneVNode } from 'vue';

export default {
  props: {
    node: {
      type: Object,
    },

    props: {
      type: Object,
    },
  },

  render() {
    return cloneVNode(this.node, {
      ...this.node.props,
      ...this.props,
    });
  },
};
</script>
